__webpack_require__.p = "/algebra-interactive/public/";